import { render, staticRenderFns } from "./DocumentView.vue?vue&type=template&id=651c552c&"
import script from "./DocumentView.vue?vue&type=script&lang=ts&"
export * from "./DocumentView.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports